<template>
    <div>
        <table class="table table-bordered table-sm mt-4">
            <tbody>
                <tr v-for="option of options" :key="option.id">
                    <td width="15%" :class="optionClass(option.value)" @click="set(option.value)">{{ option.text }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    props: ["question", "options", "answer"],
    data() {
        return {
            ans: this.answer,
        };
    },
    computed: {
        ...mapGetters(["getEvaluation"]),
    },
    methods: {
        optionClass(option) {
            if (this.ans == option) {
                return "p-4 table-success";
            }

            return "p-4 text-light";
        },
        set(answer) {
            this.ans = answer;

            this.setAnswer({
                question: this.question,
                answer: answer,
            });
        },
        ...mapActions(["setAnswer"]),
    },
};
</script>

<style>
</style>
